import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, formatApiError } from "../../lib/api";
import { PanelTitle, StatCard, money } from "../office/ui";
import { CommissionsTable } from "../office/EarningsPanel";

export const PayButton = ({ c, onPaid }) => {
  const [busy, setBusy] = useState(false);
  if (c.status !== "pendiente") return null;
  const pay = async () => {
    const tx = window.prompt(`Pagar ${money(c.amount)} a ${c.beneficiary_name} (${c.beneficiary_id}).\nHash de la transacción (opcional):`, "");
    if (tx === null) return;
    setBusy(true);
    try {
      await api.post(`/admin/commissions/${c.id}/pay`, { tx_hash: tx });
      toast.success("Comisión marcada como pagada");
      onPaid();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={pay} disabled={busy || !c.payable} title={c.payable ? "" : "El beneficiario aún no paga su membresía"} className="rounded-full bg-ink px-3.5 py-2 text-xs font-semibold text-white disabled:cursor-not-allowed disabled:opacity-40" data-testid={`commission-pay-${c.id}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Marcar pagada"}
    </button>
  );
};

export const MlmCommissionsPanel = () => {
  const [distId, setDistId] = useState("");
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/admin/commissions", { params: { dist_id: distId } });
      setData(d);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [distId]);
  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  const s = data?.summary;
  return (
    <div data-testid="mlm-commissions-panel">
      <PanelTitle title="Comisiones de red" text="Control de comisiones generadas por membresías pagadas: cuáles ya pagaste y cuáles están pendientes. Marca cada pago con su fecha y hash de transacción.">
        <Input value={distId} onChange={(e) => setDistId(e.target.value)} placeholder="Filtrar por ID de beneficiario" className="h-11 w-full bg-white sm:w-64" data-testid="commissions-dist-filter" />
      </PanelTitle>
      <div className="mt-6 grid grid-cols-3 gap-3">
        <StatCard dark label="Total generado" value={s ? money(s.total) : "…"} testId="mlm-total" />
        <StatCard label="Pagado" value={s ? money(s.paid) : "…"} testId="mlm-paid" />
        <StatCard label="Pendiente por pagar" value={s ? money(s.pending) : "…"} testId="mlm-pending" />
      </div>
      <CommissionsTable items={data?.items || []} loading={!data} showBeneficiary actions={(c) => <PayButton c={c} onPaid={load} />} testId="mlm-commissions-table" />
    </div>
  );
};
